import axios, { AxiosResponse } from "axios";
import {IAnswer, IQuestion, IResult, IResultType} from "./express-help-client-questionnaire.type";
import {BaseTable} from "mixins/types";

/**
 * Получение списков вопросов определенного опроса
 * @param id
 */
export const getQuestionnaireQuestions = (id: number): Promise<AxiosResponse<BaseTable<IQuestion>>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/question/questionnaire/${id}`, {
    params: {
      sort: 'questionWeight'
    }
  });
};

/**
 * Получение списка ответов на вопрос
 * @param questionId
 */
export const getAnswersByQuestionId = (questionId: number): Promise<AxiosResponse<IAnswer[]>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/answer/question/${questionId}`);
};

/**
 * Получение списка результатов по ID ответов
 * @param answerIds
 */
export const getResultsByAnswerIds = (answerIds: number[]): Promise<AxiosResponse<IResult[]>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/result`, {
    params: {
      answerIds: answerIds.join(",")
    }
  });
};

/**
 * Получение типа результата по ID
 * @param id
 */
export const getResultTypeById = (id: number): Promise<AxiosResponse<IResultType>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/result-type/${id}`);
};

/**
 * Получение всех типов результата
 */
export const getAllResultTypes = (): Promise<AxiosResponse<IResultType[]>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/result-type`);
};


/**
 * Получение вопроса по ID
 */
export const getQuestionById = (id: number): Promise<AxiosResponse<IQuestion>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/question/${id}`);
};
